import { styled, Typography } from '@mui/material'

export const StyledFootnote = styled(Typography)(({ theme }) => ({
  '&.defs': {
    marginTop: `${theme.spacing(5)} !important`
  },
  '.overhang': {
    position: 'absolute',
    right: '100%',
  }
}))